import { isString } from 'lodash'

import { CurrencyAmountDto } from 'types/dtos'

export const isCurrencyAmountDto = (
  value?: CurrencyAmountDto | string | null,
): value is CurrencyAmountDto => !!value && !isString(value)
